import { getTextField } from '@lender/utils';
import { object } from 'yup';

export const tableConfig = {
  docTypeName: {
    label: 'Document Type Name',
  },
  createdDate: {
    label: 'Upload Date',
  },
};

export const schema = object().shape({
  targetLoan: getTextField({ isRequired: true }),
});
